import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, IsophiCoreService, IStorage, LicenseService, LinksService, LocalStorage } from '@isophi/core-legacy';

import { environment } from '../../../environments/environment';
import { ApiConfigurationService } from '../../api';
import { PopupService } from '../../shared/services/popup.service';
import { RouterLinkFactory } from '../router/router-link.factory';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  private readonly popupService = inject(PopupService);
  protected storage: IStorage;

  public constructor(
    private isophiCoreService: IsophiCoreService,
    private apiConfigurationService: ApiConfigurationService,
    private authService: AuthService,
    private userService: UserService,
    private licenseService: LicenseService,
    private router: Router,
    private links: RouterLinkFactory,
    private linksService: LinksService
  ) {
    this.storage = new LocalStorage();
  }

  /**
   * Init application.
   */
  public async initApplication(): Promise<void> {
    // init isophi-core library
    this.isophiCoreService.setUpRequiredFields(
      environment.common.version,
      environment.common.appKeyword,
      environment.client_id,
      environment.api
    );
    this.isophiCoreService.setField('auth-api', environment.authAPI);
    this.isophiCoreService.setField('logged-teacher-api', environment.teacherAPI);
    this.isophiCoreService.setField('license-api', environment.licenseAPI);

    this.linksService.setConfig({
      dadAppUrl: environment.dadApplicationUrl,
      managementAppUrl: '',
      papAppUrl: environment.papAppUrl,
      teacherAppUrl: environment.teacherAppUrl,
    });
    // restore access token and try to load user + kindergarten
    this.authService.restoreToken(this.storage);
    await this.authService
      .authenticateByAccessToken()
      .then(() => this.apiConfigurationService.setAuthTokenForSwagger())
      .then(() => this.userService.downloadLoggedKindergarten())
      .then(() => {
        // Its users first time in this app -> show help page
        if (this.authService.loggedUser.teacher?.hasVisitedManagementApp === false && !this.userService.loggedKindergarten.isDemo) {
          this.router.navigate(this.links.help());
        }
        this.licenseService.licenseSubjectUuid = this.userService.loggedKindergarten.uuid;
      })
      .catch(() => null);
  }
}
